module.exports = __webpack_public_path__ + "static/img/wenhao.b076e22.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/wenhao.jpeg
// module id = C+Sh
// module chunks = 9